import Profile from './index';
import { IRoute } from '../../utils/navigation/routes';
import CustomerAgreement from './CustomerAgreement';
import FeedbackAgreement from './CustomerAgreement/feedbackAgreement';
import PersonalData from './personalData';
import AddPersonalData from './personalData/addPersonalData';
import FeedbackAddData from './personalData/addPersonalData/feedbackAddData';
import ChangePersonalData from './personalData/changePersonalData';
import FeedbackChangeData from './personalData/changePersonalData/feedbackChangeData';
import UpdatePassword from './updatePassword';
import UpdatePasswordFeedback from './updatePassword/UpdatePasswordFeedback';
import CancelChangeOwner from './changeOfOwnership/Cancel';
import NewCustomerForm from './changeOfOwnership/newCustomerForm';
import FeedbackChangeOwnership from './changeOfOwnership/Feedback';
import ProductSelection from './changeOfOwnership/ProductSelectionData';
import ContactSelectionContractSingning from './changeOfOwnership/contactSelectionContractSingning';
import ContinueChangeOwnership from './changeOfOwnership/Continue';
import SingContract from './changeOfOwnership/signContract';
import { CustomerAccounts } from './changeOfOwnership/customerAccounts';
import UpdatePersonalData from './personalData/updateContacts/update';
import SelectBankAccount from './personalData/changeBankAccount';
import FeedbackChangeBankAccount from './personalData/changeBankAccount/feedbackBankAccount';
import UpdateBankAccount from './personalData/changeBankAccount/updateBankAccount';
import FeedbackContactsValidate from './personalData/updateContacts/feedback';
import ContactsValidate from './personalData/updateContacts/validateVerify';
import ContactsVerify from './personalData/updateContacts/verifySend';
import EscalationContacts from '../Escalation/OtpNewFlow/escalation';
import EscalationContactsVerify from '../Escalation/OtpNewFlow/validateOtp';

export const profileRoutes: IRoute[] = [
    { path: '/profile', element: <Profile /> },
    { path: '/profile/personal-data', element: <PersonalData /> },
    { path: '/profile/customer-agreement', element: <CustomerAgreement /> },
    { path: '/profile/customer-agreement/feedback', element: <FeedbackAgreement /> },
    { path: '/profile/personal-data/change', element: <ChangePersonalData /> },
    { path: '/profile/personal-data/change/feedback', element: <FeedbackChangeData /> },
    { path: '/profile/personal-data/add', element: <AddPersonalData /> },
    { path: '/profile/personal-data/add/feedback', element: <FeedbackAddData /> },
    { path: '/profile/update-password', element: <UpdatePassword /> },
    { path: '/profile/update-password/feedback', element: <UpdatePasswordFeedback /> },
    { path: '/change-ownership/cancel', element: <CancelChangeOwner /> },
    { path: '/change-ownership/new-user', element: <NewCustomerForm /> },
    { path: '/change-ownership/product-selection', element: <ProductSelection /> },
    { path: '/change-ownership/feedback', element: <FeedbackChangeOwnership /> },
    { path: '/change-ownership/contact-media', element: <ContactSelectionContractSingning /> },
    { path: '/change-ownership/continue', element: <ContinueChangeOwnership /> },
    { path: '/change-ownership/sing-contract', element: <SingContract /> },
    { path: '/change-ownership/customer-accounts', element: <CustomerAccounts /> },
       //UPDATE DATA PERSONAL
    { path: '/escalation/contacts', element: <EscalationContacts /> },
    { path: '/escalation/contacts/verify', element: <EscalationContactsVerify /> },
    { path: '/update-personal-data', element: <UpdatePersonalData /> },
    { path: '/contacts/verify', element: <ContactsVerify /> },
    { path: '/select-bank-account', element: <SelectBankAccount /> },
    { path: '/update-bank-account', element: <UpdateBankAccount /> },
    { path: '/update-bank-account/feedback', element: <FeedbackChangeBankAccount /> },
    { path: '/contacts/validate', element: <ContactsValidate /> },
    { path: '/feedback/contacts/validate', element: <FeedbackContactsValidate /> },
];
